export default __webpack_public_path__ + "static/media/zloii_eclier.830bef5b.png";